module.exports = __webpack_public_path__ + "catalog/items/firesafety/Evacuation-Bed/Evacuation-Bed.svg";